var trigger = require("pjax/lib/events/trigger.js"),
	Pjax = require("pjax"),
	AOS = require("aos/dist/aos.js"),
	_ = require('lodash');

var defaultAnalytics = function () {
	return undefined
};

var pjax = new Pjax({
	elements: "a[href^='/']:not(.noPjax)", // default is "a[href], form[action]"
	selectors: ["head title", ".content-container", ".header--container", ".newChatWidget"],
	analytics: defaultAnalytics,
	cacheBust: false,
	history: true,
	requestOptions: {
		timeout: 0
	}
});

function postContentUpdate () {
	$(".content-container").foundation();
	trigger(document, "latte:init");

	/* window.location.search added to support new pjax based search */
	dataLayer.push({
		'event': 'virtualPageview',
		'virtualUrl': window.location.pathname + window.location.search
	});
	//Add custom event for Bounce Exchange
    trigger(document, 'bxPageLoad.bx-reinit');

    //Custom event for loading external scripts
    window.dispatchEvent(new Event('locationchange'));

	//Trustpilot widget Re-initialization after pjax update
	if (window.Trustpilot && window.Trustpilot.Modules && window.Trustpilot.Modules.WidgetManagement) {
		window.Trustpilot.Modules.WidgetManagement.initializeOnPageLoad();
	}
	//Affirm widget Re-initialization after pjax update
	if (window && window.affirm && window.affirm.ui && window.affirm.ui.ready()) {
		window.affirm.ui.refresh();
	}

	//after pjax update we need to update animation script and trigger hard refresh
	updateAnimationCode();
	AOS.refreshHard();
}

//Check elements is in viewport or not, return boolean
var InViewCheck = function (el) {
	//check https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
	if (el && typeof el.getBoundingClientRect === 'function') {//if check to see if browser support this function
		var rect = el.getBoundingClientRect(),
			vWidth = window.innerWidth || doc.documentElement.clientWidth,
			vHeight = window.innerHeight || doc.documentElement.clientHeight,
			efp = function (x, y) { return document.elementFromPoint(x, y) };

		// Return false if it's not in the viewport
		if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight)
			return false;

		// Return true if any of its four corners are visible
		return (
			el.contains(efp(rect.left, rect.top))
			|| el.contains(efp(rect.right, rect.top))
			|| el.contains(efp(rect.right, rect.bottom))
			|| el.contains(efp(rect.left, rect.bottom))
		);
	}
	return false;
}

//check each `animation` class if it is not in viewport then we append the AOS animation data attr
var updateAnimationCode = function () {
	_.forEach($('.animation'), function (v) {
		//only apply when NOT in view
		if (!InViewCheck(v)) {
			$(v).attr('data-aos', 'fade-up');
		}
	});
}

//list to scroll event listener to trigger animation attribute update & AOS init
//NOTE: if no scroll event then all dom elements should be there on page, meaning robot can see all elements
window.addEventListener('scroll', function (e) {
	AOS.refresh();
});

$(document).foundation();
$(window).on("load", function () {
	//Add GTM event for loading marketing tags/pixels
	dataLayer.push({
		'addMarketingTags': true,
	});

	//if the lead_source span exist in footer then add value to Session Storage
	if ($('#lead_source').length !== 0 && $('#lead_source').attr('data-lead_source') !== '') {
		helper.setSessionStorage('lead_source', $('#lead_source').attr('data-lead_source'))
	}

	updateAnimationCode();
	AOS.init({
		disable: window.innerWidth < 1024, //disable for screen less than 1024
		anchorPlacement: 'top-bottom',
		once: true
	});

	trigger(document, "latte:init");

});

function removeContainerContent (options) {
	if (options && options.fragment) {
		//TODO fragment load
	} else {
		$(".content-container").fadeOut(200);
	}
	$(".remodal-wrapper, .tooltip").remove();
}

document.addEventListener("pjax:success", postContentUpdate);
document.addEventListener("pjax:send", removeContainerContent);

function loadUrl (url, options) {
	if (url.indexOf('https:') !== -1) { //if the url contains `https` then we just fall back to normal redirect.
		window.location.href = url;
	} else {
		var selectors = ["title", ".content-container", ".header--container", ".newChatWidget"]; //fixed: update title, header container and content container
		var scrollTo = options && options.scrollTo || false;
		var options = {
			selectors: selectors,
			scrollTo: scrollTo,
			fragment: true,
			analytics: defaultAnalytics,
			history: true,
			cacheBust: false,
			requestOptions: {
				timeout: 0
			}
		};
		pjax.loadUrl(url, options);
	}
};

exports.loadUrl = loadUrl;
window.loadUrl = loadUrl;



//////////////////
// WEBPACK FOOTER
// ./public/js/lib/pjax.js
// module id = 3
// module chunks = 0